import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import {
  DeliveryStore,
  TempHour,
  TempHourService,
} from '@/services/TempHour/TempHourService';

export type TempHourListResponse = {
  temp_hours: TempHour[];
  delivery_stores: DeliveryStore[];
};

export const useTempHourList = async (
  siteId: string
): Promise<TempHourListResponse> => {
  const tempHourService = new TempHourService(getClient());
  try {
    const res = await tempHourService.list(siteId);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};

export const useTempHourDetail = async (id: string): Promise<TempHour> => {
  const tempHourService = new TempHourService(getClient());
  try {
    const res = await tempHourService.get(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};

export const useTempHourCreate = async (
  siteId: string,
  startTime: string,
  endTime: string,
  isClosed: boolean,
  deliveryStoreIds: string[]
): Promise<void> => {
  const tempHourService = new TempHourService(getClient());
  try {
    const res = await tempHourService.create(
      siteId,
      startTime,
      endTime,
      isClosed,
      deliveryStoreIds
    );
    return res;
  } catch (error) {
    // @ts-ignore TS18046
    if (error.status === 400) {
      // @ts-ignore TS18046
      alert(error.message);
      throw error;
    }
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};

export const useTempHourUpdate = async (
  id: string,
  startTime: string,
  endTime: string,
  isClosed: boolean,
  deliveryStoreIds: string[]
): Promise<void> => {
  const tempHourService = new TempHourService(getClient());
  try {
    const res = await tempHourService.update(
      id,
      startTime,
      endTime,
      isClosed,
      deliveryStoreIds
    );
    return res;
  } catch (error) {
    // @ts-ignore TS18046
    if (error.status === 400) {
      // @ts-ignore TS18046
      alert(error.message);
      throw error;
    }
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};

export const useTempHourDelete = async (id: string): Promise<void> => {
  const tempHourService = new TempHourService(getClient());
  try {
    const res = await tempHourService.delete(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
